import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { SessionTimeoutService } from '../service/session/session-timeout.service';

/**
 * Interceptor that resets the session timeout when a successful response is received.
 */

@Injectable()
export class SessionTimeoutInterceptor implements HttpInterceptor {
    private static readonly DEBOUNCE_MS = 1_000;

    private readonly _sessionTimeoutService: SessionTimeoutService = inject(SessionTimeoutService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse && event.status !== 401 && event.status < 500) {
                    this._sessionTimeoutService.resetOnActivity();
                }
            })
        );
    }
}
